import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { LoginService } from '../../login/login.service';
import { IPermiso } from 'modelos/src';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { Router } from '@angular/router';
import { PermisosEntidadesService } from '../../../auxiliares/servicios/http/permisos-entidades.service';
import { firstValueFrom } from 'rxjs';
import { ThemesService } from '../../../auxiliares/servicios/themes.service';
import { TemaRuntimeService } from '../../../auxiliares/servicios/tema-runtime.service';
import { Observable } from 'rxjs';
import { ITema } from 'modelos/src';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrl: './usuario.component.scss',
  standalone: false,
})
export class UsuarioComponent implements OnInit {
  private loginService = inject(LoginService);
  helper = inject(HelperService);
  permisosEntidadesService = inject(PermisosEntidadesService);
  private router = inject(Router);
  temas = inject(ThemesService);
  private temaRuntime = inject(TemaRuntimeService);

  public usuario = LoginService.getUsuario();
  public iniciales = this.getIniciales(
    this.usuario?.datosPersonales?.nombre || this.usuario?.usuario,
  );
  public permisosUsuario?: IPermiso[];
  public tema$: Observable<ITema | null>;

  @Output() permisoChanged = new EventEmitter<void>();

  constructor() {
    this.tema$ = this.temaRuntime.tema$;
  }

  /** Iniciales del nombre (o del usuario si no cargó nombre), hasta dos letras. */
  private getIniciales(nombre?: string) {
    const palabras = (nombre || '').trim().split(/\s+/).filter(Boolean);
    if (!palabras.length) return '?';
    const iniciales =
      palabras.length > 1
        ? palabras[0][0] + palabras[palabras.length - 1][0]
        : palabras[0].slice(0, 2);
    return iniciales.toUpperCase();
  }

  public async cambiarPermisos(permiso: IPermiso) {
    LoginService.setIdPermiso(permiso._id);
    LoginService.setPermisoActual(permiso);

    // Obtener el cliente actualizado del servidor
    try {
      const token = LoginService.getAccessToken();
      const clienteActualizado = await firstValueFrom(
        this.loginService.getClientePropio(token, permiso._id),
      );
      this.loginService.setCliente(clienteActualizado);
      this.temas.setTema(clienteActualizado?.config);
    } catch (error) {
      console.error('Error al obtener cliente actualizado:', error);
      // Si falla, usar el cliente del permiso como fallback
      this.loginService.setCliente(permiso.cliente);
      this.temas.setTema(permiso.cliente?.config);
    }

    this.permisosEntidadesService.permisoElegido = permiso;
    this.helper.checkPermisos();

    this.permisoChanged.emit();

    // Realizar navegación automática basada en módulos habilitados
    this.helper.navegacionAutomaticaPorModulos();
  }

  public puedeCambiarPermiso() {
    return this.permisosUsuario?.length > 1;
  }

  ngOnInit() {
    this.helper.checkPermisos();
    this.permisosUsuario = LoginService.getPermisosUsuario()?.filter(
      (p) => !!p.activo,
    );
  }
}
